<template>
  <nav
    class="bg-slate-700 flex flex-col justify-start relative z-10 pt-4 pb-4 px-4 h-full transition-all ease-in-out"
    :class="modelValue ? 'w-52' : 'w-17'"
  >
    <div class="flex items-center gap-2"
        :class="modelValue ? 'justify-end' : 'justify-center'">
      <button @click="toggleSidebar">
          <UCIcon name="menu" customClass="bg-white w-8 h-8" />
      </button>
    </div>

    <hr class="mt-5" />
    <ul class="flex-1 flex flex-col space-y-2 bg-slate-700" style="font-family: '맑은 고딕', 'Malgun Gothic', sans-serif;">
      <li v-for="menu in menus" :key="menu.path">
        <a  @click="onMenuClick(menu)"
            class="flex items-center gap-2 px-2 py-2 hover:bg-gray-200 text-base cursor-pointer"
            :class="{
              'text-white font-bold bg-slate-800': tabStore.activePath === menu.path,
              'text-slate-400 font-normal': tabStore.activePath !== menu.path }">
          <UCIcon :name="menu.icon" :customClass="tabStore.activePath === menu.path ? 'bg-white w-8 h-8':'bg-slate-400 w-8 h-8'" />
          <span v-if="modelValue" class="ml-3 whitespace-nowrap">
            {{ menu.name }}
          </span>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from "vue";
import { useRouter } from "vue-router";
import { useTabStore } from "@/store/tabStore";
import UCIcon from '@/components/UserControl/UCIcon.vue';

const router = useRouter();
const tabStore = useTabStore();

const props = defineProps({
  modelValue: Boolean,
});
const emit = defineEmits(["update:modelValue"]);

const toggleSidebar = () => {
  // console.log("toggleSidebar");
  emit("update:modelValue", !props.modelValue);
};

const sidebarClass = computed(
  () => (props.modelValue ? "translate-x-0 w-64" : "-translate-x-full w-0")

  //"translate-x-0 w-64"
  //"-translate-x-full w-0"
);

// main.js에 라우터에 메뉴 정보와 동일하게 관리할수 있으면 좋을거 같음
const menus = [
  {
    name: "Home",
    path: "/scm/home",
    icon: 'home-circle',
  },
  {
    name: "주문현황",
    path: "/scm/OrderList",
    icon: 'cube-outline'
  },
  {
    name: "출고일보",
    path: "/scm/ShipmentList",
    icon: 'clipboard-check',
  },
  {
    name: "미납현황",
    path: "/scm/UndeliveredList",
    icon: 'cash-multiple',
  },
  {
    name: "연체료현황",
    path: "/scm/LateFeeList",
    icon: 'card-bulleted',
  },
  {
    name: "NCR현황",
    path: "/scm/NCRList",
    icon: 'chart-box',
  },
];

function onMenuClick(menu) {
  // console.log("onMenuClick menu router", menu, router);

  //console.log(tabStore.tabs);

  tabStore.addTab(menu);
  router.push(menu.path);

  // console.log("tabStore", tabStore);
}
</script>
